import type {
  ContextAnalysisResult,
  ListMeetingsResponse,
  Meeting,
  MeetingSetup,
  UploadContextResponse,
} from "@scoach/types";
import { api } from "../../lib/http.ts";

export const preMeetingApi = {
  fetchMeeting: (id: string) => api<Meeting>(`/meetings/${id}`),

  patchMeeting: (id: string, patch: Partial<Meeting>) =>
    api<Meeting>(`/meetings/${id}`, { method: "PATCH", body: patch }),

  setup: (id: string, body: MeetingSetup) =>
    api<Meeting>(`/meetings/${id}/setup`, { method: "POST", body }),

  uploadContext: (id: string, files: File[]) => {
    const fd = new FormData();
    for (const f of files) fd.append("files", f, f.name);
    return api<UploadContextResponse>(`/meetings/${id}/context`, { method: "POST", body: fd });
  },

  /** Import a context doc from a Google Drive/Docs link (token → X-Drive-Token). */
  importContextLink: (id: string, url: string, googleToken?: string) =>
    api<UploadContextResponse>(`/meetings/${id}/context/link`, {
      method: "POST",
      body: { url },
      headers: googleToken ? { "X-Drive-Token": googleToken } : undefined,
    }),

  removeContext: (id: string, fileId: string) =>
    api<{ ok: boolean }>(`/meetings/${id}/context/${fileId}`, { method: "DELETE" }),

  startAnalyze: (id: string) =>
    api<{ jobId: string }>(`/meetings/${id}/context/analyze`, { method: "POST", body: {} }),

  pollAnalyze: (id: string) => api<ContextAnalysisResult>(`/meetings/${id}/context/analysis`),

  scheduleMeeting: (id: string, scheduledAt: string) =>
    api<Meeting>(`/meetings/${id}`, { method: "PATCH", body: { scheduledAt } }),

  fetchAllMeetings: () => api<ListMeetingsResponse>("/meetings").then((r) => r.items),
};
